@use '@design/design-tokens/typography/typography' as *;

.stepContainer {
  display: flex;
  padding: 9px;
  align-items: center;
  border-radius: 50%;
  border: 2px solid var(--border-disabled);

  &.active {
    border-color: var(--border-primary);
  }
}

.dottedLine {
  min-width: 36px;
  flex-grow: 1;
  border-bottom: 2px dotted var(--border-disabled);

  &.active {
    border-bottom-color: var(--border-primary);
  }
}

.connector {
  display: flex;
  padding: 4px 8px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  border: 1px solid var(--border-disabled);
  background: var(--background-default);
  color: var(--text-disabled);

  &.active {
    border-color: var(--border-primary);
    background: var(--action-primary-soft-hover);
    color: var(--text-primary);
  }
}

.stepLogo {
  aspect-ratio: 1/1;
  border-radius: 50%;
  background-color: var(--surface-inverse);
}

.fallbackLogo {
  cursor: default;
  display: flex;
  border-radius: 50%;
  justify-content: center;
  align-items: center;
  color: var(--text-default);
  background-color: var(--surface-default);
  @include typography-v2-title-sm;

  &.active {
    background-color: var(--icon-decorative-blue);
  }
}

.customLogo {
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
}
